import React, { useEffect } from "react";
import {
  registerUser,
  autologinWithJWT,
  saveJwtForUser,
  getJwtForUser,
  loginUser,
} from "./action.ts";

const Offers: React.FC = () => {
  useEffect(() => {
    sessionStorage.removeItem('trips_active_tab');
    async function generateAndRedirect() {
      const storedUser = localStorage.getItem("userdetails");
      if (!storedUser) {
        console.error('No "userdetails" found in localStorage');
        return;
      }

      let parsedUser;
      try {
        parsedUser = JSON.parse(storedUser);
      } catch {
        console.error('Invalid JSON in localStorage for "userdetails"');
        return;
      }

      const trackyoUser = parsedUser?.user;
      if (!trackyoUser) {
        console.error("Trackyo user object missing");
        return;
      }

      const name = trackyoUser.name;
      const phone = trackyoUser.phone;
      const safeName = name.replace(/\s+/g, "").toLowerCase();
      const email = trackyoUser.email || `${safeName}${phone}@email.com`;

      if (!email || !name || !phone) {
        console.error("Missing email, name, or phone from Trackyo data.");
        return;
      }

      const existingJwt = getJwtForUser(phone);
      if (existingJwt) {
        console.log(`Found stored JWT for ${phone} — verifying user...`);

        let checkResult = await registerUser(email, name, phone);

        if (checkResult?.jwt) {
          saveJwtForUser(phone, checkResult.jwt);
          autologinWithJWT(checkResult.jwt);
          return;
        } else if (checkResult?.exists) {
          autologinWithJWT(existingJwt);
          return;
        } else {
          console.warn(`JWT invalid, re-registering ${phone}...`);
          const reRegisterResult = await registerUser(email, name, phone);

          if (reRegisterResult?.jwt) {
            saveJwtForUser(phone, reRegisterResult.jwt);
            autologinWithJWT(reRegisterResult.jwt);
            return;
          }
        }
      }

      // No stored JWT → new user or no login yet
      const registerResult = await registerUser(email, name, phone);

      if (registerResult?.jwt) {
        saveJwtForUser(phone, registerResult.jwt);
        autologinWithJWT(registerResult.jwt);
      } else if (registerResult?.exists) {
        console.warn(
          `User ${email} exists but no JWT — attempting login with known password.`
        );

        const password = `${name}${phone}`; 

        const loginResult = await loginUser(email, password);

        if (loginResult?.jwt) {
          saveJwtForUser(phone, loginResult.jwt);
          autologinWithJWT(loginResult.jwt);
          return;
        } else {
          console.warn(
            "Login with known password failed — redirecting to login page."
          );
          window.location.href = "https://dev1offers.trackyo.in/wp-login.php";
          return;
        }
      } else {
        console.error("No JWT — cannot auto-login.");
      }
    }

    generateAndRedirect();
  }, []);

  return <div>Redirecting to Offers page...</div>;
};

export default Offers;

